"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BoxButtons = void 0;

var _styles = require("./styles");

var _material = require("@mui/material");

var _jsxRuntime = require("react/jsx-runtime");

var BoxButtons = function BoxButtons(_ref) {
  var showAdd = _ref.showAdd,
      onAdd = _ref.onAdd,
      onDelete = _ref.onDelete,
      isTheFirstBox = _ref.isTheFirstBox,
      index = _ref.index;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    index: index,
    children: [!isTheFirstBox && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Button, {
      variant: "outlined",
      className: "button-circle",
      onClick: onDelete,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ContainerIcon, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "iconos-out",
          children: "delete_forever"
        })
      })
    }), showAdd && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Button, {
      onClick: onAdd,
      variant: "outlined",
      className: "button-circle",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ContainerIcon, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "iconos-out iconos-grises",
          children: "add"
        })
      })
    })]
  });
};

exports.BoxButtons = BoxButtons;